import React, { useEffect, useState } from 'react'
import { ComponentBodyFaqGroup, Maybe } from '@/gql/generated/graphql'
import { FAQPageJsonLd } from 'next-seo';

type Props = {
  data: Maybe<ComponentBodyFaqGroup>
}

function FaqLd(props: Props) {
  const [faqs, setFaqs] = useState<any[]>()

  useEffect(()=> {
    let entries = props.data?.entries?.map((entry) => {
      return {
        questionName: entry?.question,
        acceptedAnswerText: entry?.textAnswer
      }
    });
    setFaqs(entries);
  }, [])
  
  return (
    <FAQPageJsonLd
      mainEntity={faqs || []}
    />
  )
}

export default FaqLd